import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouterProvider } from 'react-router';

import { createAppRouter } from './AppRouter';
import useAuth from './components/AppLayout/hooks/useAuth';
import { fetchUserData } from './redux/user/actions';

const RouterGuard = (): React.JSX.Element | null => {
  const { initialized, authenticated, email } = useAuth();
  const [appRouter, setAppRouter] = useState<ReturnType<typeof createAppRouter> | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialized) return;

    if (authenticated) {
      dispatch(fetchUserData({ email }));
    }

    // Build the router once, the first time MSAL settles — recreating it on every
    // auth transition would discard in-flight navigation/loader state and re-run
    // authenticatedLoader before MSAL's own state is guaranteed to be ready.
    setAppRouter(prev => prev ?? createAppRouter());
  }, [initialized, authenticated, email, dispatch]);

  if (!appRouter) return null;

  return <RouterProvider router={appRouter} />;
};

export default RouterGuard;
